import { render, staticRenderFns } from "./outer.vue?vue&type=template&id=e5101bfe&scoped=true&"
import script from "./outer.vue?vue&type=script&lang=js&"
export * from "./outer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5101bfe",
  null
  
)

export default component.exports